<template>
  <div>

    <div class="d-flex align-items-center mb-3 pb-2">
      <span class="fa fa-list mr-2"></span>

      <span>{{ $route.meta.title }}</span>

      <button type="button" class="btn btn-info ml-2" @click="retrieveDiets()">
        <span class="fa fa-sync mr-1" :class="{'fa-spin' : working}"></span>
        <span>بروزرسانی</span>
      </button>

      <router-link to="/diets/form" type="button" class="btn btn-success ml-2">
        <span class="fa fa-plus mr-1"></span>
        <span>ثبت جدید</span>
      </router-link>

      <div class="ml-2">
        <language-selector class="form-control" v-model="filters.language_code" @input="retrieveDiets()"/>
      </div>
    </div>

    <div class="mt-3 panel">
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>ایکون</th>
            <th>عنوان</th>
            <th>زبان</th>
            <th>&</th>
          </tr>
          </thead>

          <tbody v-if="diets && diets.data">
          <tr v-for="x in diets.data" :key="x.diet_id">
            <td>
              <img v-if="x.icon" :src="x.icon  | serverUrl" width="50"/>
            </td>
            <td>
              {{ x.title }} <br/>
              <a :href="x.permalink | serverUrl(x.language_code)" target="_blank">
                نمایش
                <span class="ml-2 fa fa-external-link"></span>
              </a>
            </td>
            <td>{{ x.language_code }}</td>
            <td>

              <router-link :to="`/diets/form/${x.diet_id}`" class="btn btn-sm p-1 btn-info">
                <span class="fa fa-edit mr-1"></span>
                ویرایش
              </router-link>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import LanguageSelector from "../../../components/LanguageSelector";
import {message, xhr} from "../../../tools/functions";

export default {
  name: "DietsIndex",
  props: {
    language_code: {default: undefined}
  },
  components: {LanguageSelector},
  data: () => ({
    working: false,
    filters: {
      language_code: undefined,
    },
    diets: {}
  }),
  methods: {
    retrieveDiets(page = 1) {
      this.working = true;
      xhr('api/v1/admin/diet', 'get', {
        page,
        ...this.filters
      })
          .then(x => this.diets = x.data)
          .catch(() => message('خطا در دریافت اطلاعات، مجددا تلاش کنید'))
          .finally(() => this.working = false)
    }
  },
  mounted() {
    this.filters.language_code = this.language_code
    this.retrieveDiets();
  }
}
</script>

<style scoped>

</style>
